import React, { useState } from "react";
import { useTheme } from "@mui/material/styles";
import CircularProgress from "@mui/material/CircularProgress";

import ControlPanelButton from "components/Flow/Controls/ControlPanelButton";
import ReplayIcon from "@mui/icons-material/Replay";
import { recalculateCommunityPathway } from "api/Community/CommunityAPI";

interface RecalculateButtonProps {
  id: string;
  reloadFlowData: () => void;
}

const RecalculateButton: React.FC<RecalculateButtonProps> = ({
  id,
  reloadFlowData,
}) => {
  const [loading, setLoading] = useState(false);

  const handleRecalculate = async () => {
    try {
      setLoading(true);

      await recalculateCommunityPathway(id); // Recalculate
      await reloadFlowData();                // Reload UI
    } catch (e) {
      console.error("Recalculation failed:", e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <ControlPanelButton
      label="Recalculate"
      icon={<ReplayIcon fontSize="small" />}
      loading={loading}     // ⭐ NEW
      onClick={handleRecalculate}
    />
  );
};

export default RecalculateButton;
